import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import {
  handleAddUserEnteredMedicationToInquiry,
  handleCreateNewUserEnteredMedication,
  handleEditUserEnteredMedication,
  handleGetUserEnteredMedicationDetails,
} from './actions';
import { IUserEnteredMedicationState } from './slice.interface';

const initialState: IUserEnteredMedicationState = {
  createdMedication: null,
  data: null,
  isLoading: false,
  error: false,
};

export const userEnteredMedicationSlice = createSlice({
  name: 'user-entered-medication',
  initialState,
  reducers: {
    removeNewUserEnteredMedication: state => {
      state.isLoading = false;
      state.error = false;
      state.createdMedication = null;
      state.data = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleCreateNewUserEnteredMedication.pending,
        (state: IUserEnteredMedicationState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleCreateNewUserEnteredMedication.rejected,
        (state: IUserEnteredMedicationState, action) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleCreateNewUserEnteredMedication.fulfilled,
        (state: IUserEnteredMedicationState, action) => {
          state.createdMedication = action.payload.data;
          state.isLoading = false;
          eventBus.emit(EventType.CREATE_NEW_MEDICATION_SUCCESS);
        },
      )
      .addCase(
        handleGetUserEnteredMedicationDetails.pending,
        (state: IUserEnteredMedicationState) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetUserEnteredMedicationDetails.rejected,
        (state: IUserEnteredMedicationState) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetUserEnteredMedicationDetails.fulfilled,
        (state: IUserEnteredMedicationState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
        },
      )
      .addCase(
        handleEditUserEnteredMedication.pending,
        (state: IUserEnteredMedicationState, action) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleEditUserEnteredMedication.rejected,
        (state: IUserEnteredMedicationState, action) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleEditUserEnteredMedication.fulfilled,
        (state: IUserEnteredMedicationState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
          eventBus.emit(EventType.EDIT_NEW_MEDICATION_SUCCESS);
        },
      )
      .addCase(
        handleAddUserEnteredMedicationToInquiry.pending,
        (state: IUserEnteredMedicationState, action) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleAddUserEnteredMedicationToInquiry.rejected,
        (state: IUserEnteredMedicationState, action) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleAddUserEnteredMedicationToInquiry.fulfilled,
        (state: IUserEnteredMedicationState, action) => {
          state.isLoading = false;
          eventBus.emit(EventType.ADD_NEW_MEDICATION_TO_INQUIRY_SUCCESS);
        },
      );
  },
});

export const { removeNewUserEnteredMedication } = userEnteredMedicationSlice.actions;

export default userEnteredMedicationSlice.reducer;
